import React, { useState } from 'react';

import { Box, Chip, Stack, Tab, Tabs } from '@mui/material';

import { useGetCustomerServiceRepAssignments } from '~/hooks/apis/loyalty/useCustomerServiceRepAssignments';
import { useGetCustomerServiceReps } from '~/hooks/apis/loyalty/useCustomerServiceReps';

import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

import AssignmentsTab from './AssignmentsTab';
import RepresentativesTab from './RepresentativesTab';

type ConciergeSubTab = 'assignments' | 'representatives';

/**
 * Concierge sub-tab: hosts the Assignments and Representatives tabs that
 * previously sat directly under the top-level Infinite Concierge page.
 */
export default function ConciergeTab() {
  const [tab, setTab] = useState<ConciergeSubTab>('assignments');

  // Pre-fetch summary counts for the tab badges.
  const assignmentsQuery = useGetCustomerServiceRepAssignments({ page: 1, pageSize: 1 });
  const repsQuery = useGetCustomerServiceReps({ page: 1, pageSize: 1 });

  const assignmentsCount = assignmentsQuery.data?.result.pageInfo.totalRecords ?? 0;
  const repsCount = repsQuery.data?.result.pageInfo.totalRecords ?? 0;

  return (
    <Box>
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as ConciergeSubTab)}>
          <Tab
            value="assignments"
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <span>Assignments</span>
                <Chip size="small" label={assignmentsCount} sx={{ height: 18, '& .MuiChip-label': { px: 0.75 } }} />
              </Stack>
            }
          />
          <Tab
            value="representatives"
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <span>Representatives</span>
                <Chip size="small" label={repsCount} sx={{ height: 18, '& .MuiChip-label': { px: 0.75 } }} />
              </Stack>
            }
          />
        </Tabs>
      </Box>

      {tab === 'assignments' && <AssignmentsTab />}
      {tab === 'representatives' && <RepresentativesTab />}
    </Box>
  );
}
